import type { InjectionKey, Ref } from "vue";

export type ArchiveFeatureId =
  | "announcement"
  | "contentHeader"
  | "contentFooter"
  | "navLinks"
  | "search";

interface ArchiveHighlightContext {
  hoveredFeature: Ref<ArchiveFeatureId | null>;
  enabledFeatures: Ref<Record<ArchiveFeatureId, boolean>>;
}

export const ARCHIVE_HIGHLIGHT_KEY: InjectionKey<ArchiveHighlightContext> =
  Symbol("archive-highlight");
